import React from 'react';
import styles from './Technologies.module.css';

const Technologies = ({ data }) => {
  if (!data) return null;
  return (
    <section id="technologies" className={`${styles.technologiesSection} section`}>
      <div className="container">
        <h2 className="section-title fade-in">{data.title}</h2>
        <div className={`${styles.technologiesGrid} fade-in`}>
          {data.items?.map((tech, idx) => (
            <div key={idx} className={`${styles.techCard} ${styles.techCard1}`}>
              <span className={styles.techIcon} aria-hidden>
                {tech.icon}
              </span>
              <span className={styles.techName}>{tech.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Technologies;


